import secureLocalStorage from "react-secure-storage";

export const getDataKeyFromLocalStorage = (key: string) => {
    const data = secureLocalStorage.getItem(key);
  if (!data) {
    return "";
  }
  return data;
};


export const setDataKeyInLocalStorage = ({
  key,
  value,
}: {
  key: string;
  value: string;
}) => {
  secureLocalStorage.setItem(key, value);
};
